import { render, staticRenderFns } from "./TOOL_COMPANY_MASTER.vue?vue&type=template&id=2bd9046c&scoped=true"
import script from "./TOOL_COMPANY_MASTER.vue?vue&type=script&lang=ts"
export * from "./TOOL_COMPANY_MASTER.vue?vue&type=script&lang=ts"
import style0 from "./TOOL_COMPANY_MASTER.vue?vue&type=style&index=0&id=2bd9046c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9046c",
  null
  
)

export default component.exports